import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HospitalService } from 'src/app/components/pages/_services';

@Component({
  selector: 'app-appointments-doctor',
  templateUrl: './doctor.component.html',
  styleUrls: ['./doctor.component.scss']
})
export class AppointmentsDoctorComponent implements OnInit , OnDestroy{
  language: any;
  SpecialtyDoctors;
  SpecialtyId;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 
  DoctorImg:boolean []= [];
  DoctorAbout:boolean [] = [];
  constructor(private translationService: TranslationService,
    private HospitalService: HospitalService,
   private route: ActivatedRoute,) { }

  ngOnInit(): void {
    
    this.SpecialtyId = this.route.snapshot.params['specialtyId'];
    this.language = this.translationService.getSelectedLanguage();
    const sb = this.HospitalService.GetAllDoctorsByDepartmentId(this.SpecialtyId).subscribe(res => {
      if (res != null) {
        this.SpecialtyDoctors = res;
        for(let i = 0 ; i < res.length ; i++)
        {
          this.DoctorImg[i] = true;
        }
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  OnMouseEnter(index)
  {
    this.DoctorImg[index] = false;
    this.DoctorAbout[index] = true;
  }
  OnMouseLeave(index)
  {
    this.DoctorImg[index] = true;
    this.DoctorAbout[index] = false;
  }
}
